<section>
  <div class="container-style">
    <div class="row">
      <div class="col-12 d-md-flex justify-content-md-between align-items-md-center px-2">
        <p class="pb-0">Adjunte los archivos del documento {{labelConsecutive}}.</p>
        <app-custom-button [title]="'Subir Archivo'" [label]="'Subir Archivo'" [severity]="'primary'" [width]="'8rem'"
          [icon]="'pi pi-upload'" [variant]="undefined" (onClick)="attach('attachFile')"
          [disabled]="disabled"></app-custom-button>
        <input id="attachFile" type="file" type="file" (change)="uploadFile($event)" hidden>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="mb-sm-0" *ngFor=" let  file of listFiles">
          <hr>
          <div class="row px-2">
            <div class="col-12 col-sm-12 col-md-2 col-lg-2 p-2 card-image">
              <span class="material-symbols-outlined"> file_present </span>
            </div>
            <div class="col-12 col-sm-12 col-md-10 col-lg-10 ps-4 p-2">
              <div>
                <p class="fw-semibold mb-1 name-image">{{file.name | filename}}</p>
                <p class="mb-1 ms-1 name-image">{{sizeFile(file.size)}} MB</p>
              </div>
              <div class="d-flex gap-2">
                <app-custom-button [title]="'Descargar'" [severity]="'primary'" [icon]="'pi pi-download'"
                  [label]="'Descargar'" [width]="'6rem'" (onClick)="downloadFile(file.name)"></app-custom-button>

                <app-custom-button [title]="'Eliminar'" [severity]="'danger'" [icon]="'pi pi-trash'"
                  [label]="'Eliminar'" [width]="'5.5rem'" [disabled]="disabled"
                  (onClick)="deleteFile(file.name)"></app-custom-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>